import { useCallback, useEffect, useState } from 'react'
import { axiosInstance } from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import { IProduct } from '../../types/product'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'

interface Props {
  handleFilterChange?: (filter: any) => void
  products?: string[]
  onSelect?: (e: any) => void
  options?: IOptionSelect<IProduct>[]
  resetAutoComplete?: string
  multiple?: boolean
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  defaultValue?: any
  value?: any
}

const ProductSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    products,
    onSelect,
    options,
    resetAutoComplete = '',
    multiple = true,
    ...rest
  } = props

  const [firstLoading, setFirstLoading] = useState<boolean>(true)
  const [searchProduct, setSearchProduct] = useState<string>('')
  const [data, setData] = useState<PaginationResponseInterface<IProduct>>()
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearchProduct, setDebouncedSearchProduct] =
    useState<string>(searchProduct)

  useEffect(() => {
    if (firstLoading) {
      handleOnProductSearch()
      setFirstLoading(false)
    }
  }, [firstLoading])

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearchProduct(searchProduct)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [searchProduct])

  useEffect(() => {
    if (debouncedSearchProduct) {
      handleOnProductSearch()
    }
  }, [debouncedSearchProduct])

  const handleSearchProduct = async (value: string) => {
    setSearchProduct(value)
    //await productsList.mutate()
  }

  const handleOnProductSearch = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.get('/product', {
        params: {
          page: 1,
          perPage: 25,
          search: debouncedSearchProduct,
          startDate: '',
          endDate: '',
        },
      })
      setData(response.data)
    } catch (error) {}
    setLoading(false)
  }, [debouncedSearchProduct])

  const currentLoadingState = loading

  return (
    <>
      {multiple ? (
        <SelectSearchMultiple<IProduct>
          resetAutoComplete={resetAutoComplete}
          placeholder={'เลือกสินค้า'}
          label={`เลือกสินค้า ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={
            onSelect
              ? onSelect
              : (e) => {
                  const selectedProductIds = e?.map(
                    (product) => product?.value?.objectId,
                  )
                  handleFilterChange?.({ products: selectedProductIds })
                }
          }
          search={searchProduct}
          onSearch={handleSearchProduct}
          options={
            options
              ? options
              : data?.records
                  .filter(
                    (product: IProduct) =>
                      !products?.includes(product.objectId),
                  )
                  .map(
                    (product: IProduct) =>
                      product.isAvailable && {
                        label: `${product.name} (${product.code})`,
                        image: product.image,
                        value: product,
                      },
                  )
                  .reduce((acc: IOptionSelect<IProduct>[], product) => {
                    if (product) {
                      acc.push(product)
                    }
                    return acc
                  }, []) || ([] as IOptionSelect<IProduct>[])
          }
        />
      ) : (
        <>
          <SelectSearch<IProduct>
            {...rest}
            label={`เลือกสินค้า (1 รายการ) ${
              currentLoadingState ? 'กำลังโหลด...' : ''
            }`}
            onSelect={onSelect ? onSelect : (e) => {}}
            search={searchProduct}
            onSearch={handleSearchProduct}
            options={
              data?.records
                .filter(
                  (product: IProduct) => !products?.includes(product.name),
                )
                .map(
                  (product: IProduct) =>
                    product.isAvailable && {
                      label: `${product.name} (${product.code})`,
                      image: product.image,
                      value: product,
                    },
                )
                .reduce((acc: IOptionSelect<IProduct>[], product) => {
                  if (product) {
                    acc.push(product)
                  }
                  return acc
                }, []) || ([] as IOptionSelect<IProduct>[])
            }
          />
        </>
      )}
    </>
  )
}

export default ProductSelectSearch
